import * as React from "react";
import Svg, { Circle } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={102}
    height={138}
    viewBox="0 0 102 138"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle
      cx={103.344}
      cy={33.7331}
      r={103.344}
      fill="white"
      fillOpacity={0.16}
    />
  </Svg>
);
export default SVGComponent;
